import { getFilterTagTitleFromSlug } from '~/components/intent/slug'
import Tag from '~/components/tag'
import { formatSwitch } from '~/config/format-switch'
import { usePageContext } from '~/contexts/page-context'
import { removeElementFromArray } from '~/utils/array'
import { empty, notEmpty } from '~/utils/empty'
import { filterObjectValues } from '~/utils/objects'
import { track } from '~/utils/tracking'

import st from './styles.module.css'

const getActiveFilters = (filterConfig, allFilters, filters) => {
  if (empty(filters)) return []

  const filterItems = Object.keys(filters).reduce((acc, cur) => {
    const filterGroup = filterConfig.find((group) => group.objKey === cur)

    const filterLabels = filters[cur].reduce(
      (acc, cur) => [
        ...acc,
        {
          label: formatSwitch(allFilters, filterGroup, cur),
          group: filterGroup.objKey,
          value: cur
        }
      ],
      []
    )

    return [...acc, ...filterLabels]
  }, [])

  return filterItems
}

const ActiveFilters = ({ allFilters, selectedFilters, onChange, setShowBannerButton }) => {
  const { filterConfig, resetSlug, slug } = usePageContext()

  const onClickActiveFilter = (filter) => () => {
    track('Broadband - Deals Table', 'Clear filter tag')

    onChange({
      ...filterObjectValues(notEmpty, {
        ...selectedFilters,
        [filter.group]: removeElementFromArray(selectedFilters[filter.group], filter.value)
      })
    })
    setShowBannerButton(true)
  }

  const reset = () => {
    track('Broadband - Deals Table', 'Clear slug filter tag')

    resetSlug()
    onChange(selectedFilters)
  }

  const slugFilter = getFilterTagTitleFromSlug(slug)

  const activeFilters = getActiveFilters(filterConfig, allFilters, selectedFilters)

  return (
    <div data-cypress-id='active-filters'>
      {slugFilter && (
        <Tag className={st.activeFilters} closeButton onClose={reset}>
          {slugFilter}
        </Tag>
      )}
      {activeFilters.map((filter, filterIndex) => (
        <Tag key={filterIndex} className={st.activeFilters} closeButton onClose={onClickActiveFilter(filter)}>
          {filter.label}
        </Tag>
      ))}
    </div>
  )
}

export default ActiveFilters
